import { type FunctionComponent } from 'react';
import { ReactComponent as BlueStripGenericSVG } from '../../assets/icons/mevo/medicine/tarjaazul_generico.svg';
import IconPattern, { IconProps } from './_IconPattern';

const MedicineBlueStripGenericIcon: FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={BlueStripGenericSVG} variantPlaces={[]} {...props} />;
};

export default MedicineBlueStripGenericIcon;
